import MaPhoto from '../../img/photo/moi.jpg';
import GitHub from '../../img/icones/github.png';
import LinkedIn from '../../img/icones/linkedin.png';
import './introduction.scss';

const Introduction = () => {
  return (
    <section id="a-propos" className="intro">
      <div className="intro__content">
        <h2 className="intro__title">À propos de moi</h2>
        <p className="intro__description">

          Après 11 ans dans le secteur du tourisme, j’ai choisi de me reconvertir dans le développement web, porté par ma passion pour les nouvelles technologies.
        </p>
        <p className="intro__description">
          Formé en HTML, CSS, JavaScript et React, je développe aujourd’hui des sites web modernes et performants.
        </p>
        <p className="intro__description">
          Je suis actuellement en train de créer ma micro-entreprise spécialisée dans la conception de sites internet et d’applications, avec l’ambition d’accompagner mes clients dans leurs projets digitaux.
        </p>
        <div className="intro__links">
          <a href="https://github.com/azize1999/Portfolio" target="blank" className="intro__link">
            <img src={GitHub} alt="Lien vers mon profil GitHub" />
          </a>
          <a href="https://www.linkedin.com/in/chatti-aziz-19b190266/" target="blank" className="intro__link">
            <img src={LinkedIn} alt="Lien vers mon profil LinkedIn" />
          </a>
        </div>
      </div>
      <div className="intro__photo-container">
        <img className="intro__photo" src={MaPhoto} alt="Portrait de Aziz Chatti" />
        <h3 className="intro__name">Aziz Chatti</h3>
        <h4 className="intro__role">Développeur Web</h4>
        <p className="intro__role-secondary">Intégrateur Front-End</p>
      </div>
    </section>
  );
};

export default Introduction;
